<template>
    <Selector 
      :options="optionList" 
      @dataChange="change" 
      :disabled="disabled" 
    ></Selector>
    <!-- :style="style" -->
  </template>
  
  <script>
  import Selector from './Selector.vue'
  
  export default {
    name: 'selector',
    components: { Selector },
    props: {
      placeholder: String,
      selected: {
        type: String,
        default(){
          return "id, desc"
        }
      },
      disabled: { type: Boolean, default: false}
    },
    data() {
      // console.log( this.style ) ; 
      return {
        optionList: [
            {value: "id, desc", label:"생성일(내림)", select: true},
            {value: "id, asc", label:"생성일(오름)"},
            {value: "name, desc", label:"제목(내림)"},
            {value: "name, asc", label:"제목(오름)"},
        ]
      }
    },
    watch: {
    },
    mounted() {
      this.optionList.find(o=>o.select == true).select = false;
      // console.log( "selected", this.selected )
      // console.log( "this.optionList.find(o=>o.value == this.selected)", this.optionList.find(o=>o.value == this.selected) )
      this.optionList.find(o=>o.value == this.selected).select = true;
      this.change( this.optionList.filter(o=>o.value==this.selected)[0] )
    },
    methods : {
      change(value) {
        this.$emit('change', value);
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  </style>
  
  
  